export type DispatchRule = {
    profit_center_dispatch_rule_id: number;
    profit_center_id: number;
    profit_center_name: string;
    rule_start_time: string;
    rule_end_time: string;
    created_date?: Date;
    created_by?: number;
    modified_date?: Date | null;
    modified_by?: number | null;
    deleted_date?: Date | null;
    deleted_by?: number | null;
    update_ticket_notification_type: number | null;
    cancel_ticket_notification_type: number | null;
    notification_type: number | null;
    recall_ticket_notification_type: number | null;
    rule_type?: DispatchRuleType;
    rule_type_id?: number;      // use this when creating, updating
}

export type DispatchRuleType = {
    rule_type_id: number;
    rule_type_name: string;
    is_active: boolean;
    created_date: Date;
    created_by: number;
    modified_date: Date | null;
    modified_by: number | null;
    deleted_date: Date | null;
    deleted_by: number | null;
}

export type ProfitCenterDispatchRule = {
    profit_center_dispatch_rule_id: number;
    profit_center_id: number;
    rule_start_time: string;
    rule_end_time: string;
    rule_type_id: number;
    // created_date?: Date;
    // created_by?: number;
    update_ticket_notification_type: number | null;
    cancel_ticket_notification_type: number | null;
    notification_type: number | null;
    recall_ticket_notification_type: number | null;
}

export type DispatchRuleParams = {
    showInactive: string | null;
}

export type ProfitCenter = {
    ProfitCenterID: number;
    ProfitCenterShortDesc: string;
    ProfitCenterLongDesc: string;
    StateID: number;
    Inactive: boolean;
}

export type NotificationMethod = 1 | 2 | 3;
export const notificationMethodMap: Record<NotificationMethod, string> = {
    1: 'Call', 
    2: 'Text',
    3: 'Ignore'
};

export type NotificationTicketType = 'Default' | 'Update' | 'Cancel' | 'Recall';
export type TicketNotificationConfig = {
    label: NotificationTicketType;
    value: NotificationMethod | undefined;
    UpdateValue: (type: NotificationMethod) => void;
}